import { render } from "./VehicleDecoratorComponent.vue?vue&type=template&id=2c546695&scoped=true"
import script from "./VehicleDecoratorComponent.vue?vue&type=script&lang=js"
export * from "./VehicleDecoratorComponent.vue?vue&type=script&lang=js"

import "./VehicleDecoratorComponent.vue?vue&type=style&index=0&id=2c546695&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c546695"]])

export default __exports__